export class User {
    constructor(data) {
        this.id = data.id;
        this.name = data.name;
        this.email = data.email;
        this.accessLevel = data.accessLevel;
        this.administratorLevel = data.administratorLevel;
        this.accessId = data.accessId;
        this.isActive = data.isActive;
        this.roleId = data.roleId;
    }

    getId() {
        return this.id;
    }

    getName() {
        return this.name;
    }   

    getEmail() {
        return this.email;
    }

    getAccessLevel() {
        return this.accessLevel;
    }

    getAdministratorLevel() {
        return this.administratorLevel;
    }

    getAccessId() {
        return this.accessId;
    }

    getIsActive() {
        return this.isActive;
    }

    getRoleId() {   
        return this.roleId;
    }
}

export class UsersList {
    constructor(dataArray) {
        this.list = Array.isArray(dataArray) ? dataArray.map(user => new User(user)) : [];
    }

    getUsers() {
        return this.list;
    }
}

export class UserInvitationByIdentifier {
    constructor(identifier, data, state) {
        this.identifier = identifier;
        this.name = data?.name;
        this.email = data?.email;
        this.state = state;
    }

    getIdentifier() {
        return this.identifier;
    }

    getName() {
        return this.name;
    }

    getEmail() {
        return this.email;
    }

    getState() {
        return this.state;
    }
}

class UserInvitation {
    constructor(data) {
        this.id = data.id;
        this.name = data.name;
        this.email = data.email;
        this.accessId = data.accessId;
        this.administratorLevel = data.administratorLevel;
        this.accessLevel = data.accessLevel;
        this.roleId = data.roleId;
    }

    getId() {
        return this.id;
    }

    getName() {
        return this.name;
    }

    getEmail() {
        return this.email;
    }

    getAccessId() {
        return this.accessId;
    }

    getAdministratorLevel() {
        return this.administratorLevel;
    }

    getAccessLevel() {
        return this.accessLevel;
    }

    getRoleId() {
        return this.roleId;
    }
}
export class UserInvitationsList {
    constructor(dataArray) {
        this.list = Array.isArray(dataArray) ? dataArray.map(invitation => new UserInvitation(invitation)) : [];
    }

    getInvitations() {
        return this.list;
    }
}

export class Permissions {
  static _ALL_PERMISSIONS = [
    "notification:manage",
    "company:access",
    "user:manage",
    "payment:manage",
    "billing:read",
    "reviews:manage",
    "reports:read",
  ]

  static allPermissions() {
    return Permissions._ALL_PERMISSIONS;
  }

  constructor(permissions) {
    this.permissions = permissions.filter(permission => Permissions.allPermissions().includes(permission));
  }

  
  getActivePermissions() {
    return this.permissions;
  }

  canManageNotifications() {
    return this.permissions.includes("notification:manage");
  }

  canAccessCompany() {
    return this.permissions.includes("company:access");
  }

  canManageUsers() {
    return this.permissions.includes("user:manage");
  }

  canManagePayments() {
    return this.permissions.includes("payment:manage");
  }

  canReadBilling() {
    return this.permissions.includes("billing:read");
  }

  canManageReviews() {
    return this.permissions.includes("reviews:manage");
  }

  canReadReports() {
    return this.permissions.includes("reports:read");
  }

}

export class Role {
    constructor(data) {
        this.id = data?.id;
        this.name = data?.name;
        this.permissions = new Permissions(data?.permissions || []);
        this.systemRole = data?.systemRole;
    }

    getId() {
        return this.id;
    }

    getName() {
        return this.name;
    }

    getPermissions() {
        return this.permissions;
    }

    isSystemRole() {
        return this.systemRole;
    }
}

export class RolesList {
    constructor(dataArray) {
        this.list = Array.isArray(dataArray) ? dataArray.map(role => new Role(role)) : [];
    }

    getRoles() {
        return this.list;
    }

    getRoleById(id) {
        return this.list.find(role => role.id === id);
    }
}
